/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";

export const LoadMoreTarget = ({ collection, offset, limit }) => {
  return (
    <div
      id={`ELM-${collection.id}`}
      data-collection-slug={collection["slug"]}
      data-collection-offset={offset}
      data-collection-limit={limit}
    />
  );
};

LoadMoreTarget.propTypes = {
  collection: PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string
  }),
  offset: PropTypes.number,
  limit: PropTypes.number
};
